module.exports = __webpack_public_path__ + "static/image/history/pc/201601.jpg?aed46cd0";